
export default class Model {

  // 添加散点图层
  static setModelStyle(params) {
    let defaultConfig = {
      id: "modelId",
      alpha: 1,
      scale: 1,
      maskType: "none",
      maskAlpha: 0,
      maskColor: "#ff0000",
      maskPicture: "arrow",
      maskPictureScale: 1.0,
      maskFlowSpeed: 1.0,
      maskFlowDirection: 90,
      includeChildren: true,
      xRay: "off",
    }
    let resConfig = Object.assign({}, defaultConfig, params);
    window.appInstance.uniCall("setModelStyle", resConfig, res => {
      console.log('设置模型样式', resConfig, res);
    });
  }
  // 添加散点图层
  static setModelVisibility(params) {
    let defaultConfig = {
      ids: [],
      visible: false
    }
    let jsonData = Object.assign({}, defaultConfig, params);
    appInstance.uniCall('setModelVisibility', jsonData, res => {
      console.log('setModelVisibility', jsonData, res);
    })
  }

  // 播放模型动画
  static playAnimation(params) {
    let defaultConfig = {
      id: '<#id#>', // 模型对象 id，新建时调用者自己传入的唯一标识，用于各种操作的对象识别
      name: 'animationName01', // 动画名称
      state: 'pause'
    }
    let jsonData = Object.assign({}, defaultConfig, params);
    window.appInstance.uniCall('playModelAnimation', jsonData, res => {
      console.log('播放模型动画', jsonData, res)
    })
  }
  // 设置模型闪烁
  static setModelTwinkle(params) {
    let index = 0;
    let colors = ['#ff0000', '#4A87AC']
    let timer = setInterval(() => {
      index++
      this.setModelStyle({
        id: params.id,
        alpha: 1,
        scale: 1,
        maskType: "color",
        maskAlpha: 1,
        maskColor: colors[index % 2],
      })
      if (index >= 10) {
        clearInterval(timer)
      }
    }, 300)
  }
}
